import axios from 'axios'

const loc = document.location

if (!loc.origin) {
  loc.origin =
    loc.protocol + '//' +
    loc.hostname + (loc.port ? ':' + document.location.port : '')
}

export default axios.create(
  {
    baseURL: loc.origin + '/api/v1',
    headers: { Pragma: 'no-cache' }
  }
)
